// @flow
import React from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type Props = {
  classes: Object,
  value: string,
  label: string,
  onChange: Function
}

function Checkbox({ classes: c, value, label, onChange }: Props) {
  return (
    <div
      className={c.container}
      onClick={() => onChange(!value)}
    >
      <div className={classNames(c.checkbox, value && c.checked)} />
      <span className={c.label}>
        {label}
      </span>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '20px',
    cursor: 'pointer'
  },
  checkbox: {
    width: '16px',
    height: '16px',
    outline: '1px solid hsla(0, 0%, 0%, .25)',
    marginRight: '5px',
    padding: '3px',
    transition: 'background ease .2s',
    borderRadius: '2px',
    boxShadow: '0 0 3px #ddd',
    position: 'relative'
  },
  checked: {
    '&:after': {
      content: '"check"',
      fontFamily: 'Material Icons',
      position: 'absolute',
      top: '-1px',
      left: '0'
    }
  },
  label: {
    fontFamily: FONT_FAMILY_ROBOTO,
    fontSize: '16px',
    marginLeft: '10px',
    fontWeight: '300'
  }
};

export default injectSheet(styles)(Checkbox);
